import React, { Component } from 'react';
import { getStandardTexts, saveStandardText, createStandardText, deleteStandardText } from '../../utility/standardText';
import WaitForState from '../WaitForState';
import { addMessage } from '../../actions/messages';
import { withRouter } from 'react-router';
import { withUser } from '../../utility/withUser';
import { connect } from 'react-redux';
import { hasOneOfPermissions } from '../../utility/account';
import './index.css';

/**
 * Component for showing standard texts.
 *
 * @extends React.Component
 */
class StandardTexts extends Component {
  /** @inheritdoc */
  constructor(props) {
    super(props);
    this.state = {
      standardTexts: null,
      doneWorking: true,
      editAnyAllowed: null,
      editOwnAllowed: null,
      disabled: false,
    }
  }

  /**
   * Handle when an standard text has been updated.
   */
  handleStandardTextUpdate = (standardTextId, field, e) => {
    if (!this.state.editAnyAllowed && !(this.state.standardTexts[standardTextId].user_id === this.props.user.id && this.state.editOwnAllowed)) {
      return;
    }

    var standardTextsC = this.state.standardTexts;
    standardTextsC[standardTextId][field] = e.target.value;
    this.setState({standardTexts: standardTextsC});

    // We don't want to trigger a request every time the user touches his
    // keyboard. Only trigger when he has not done so in half a second.
    if (this.saveTimeout === undefined) {
      this.saveTimeout = {};
    }
    if (this.saveTimeout[standardTextId + '-' + field] !== undefined) {
      window.clearTimeout(this.saveTimeout[standardTextId + '-' + field]);
    }
    this.saveTimeout[standardTextId + '-' + field] = window.setTimeout(() => {
      this.setState({doneWorking: false});
      if (this.state.standardTexts[standardTextId].new) {
        this.setState({disabled: true});
        var newStandardText = this.state.standardTexts[standardTextId];
        delete newStandardText.id;
        delete newStandardText.new;

        createStandardText(this.props.user.id, newStandardText, this.props.token, this.props.history, (response) => {
          if (response.status !== 200) {
            this.props.dispatch(addMessage('Fejl under gemning af standardtekst. Prøv venligst igen senere.', 'danger'));
          }
          this.setState({doneWorking: true, disabled: false});
          this.fetchStandardTexts();
        });
      } else {
        saveStandardText(this.props.user.id, standardTextId, field, this.state.standardTexts[standardTextId][field], this.props.token, this.props.history, (response) => {
          if (response.status !== 200) {
            this.props.dispatch(addMessage('Fejl under gemning af standardtekst. Prøv venligst igen senere.', 'danger'));
          }
          this.setState({doneWorking: true});
        });
      }
    }, 500);
  }

  /**
   * Fetch permission to edit standard texts.
   */
  fetchEditAllowedPermission = () => {
    hasOneOfPermissions(this.props.user.id, ["modify any user standard text", "modify own user standard text"], this.props.token, this.props.history, (a, allowed) => {
      this.setState({editAnyAllowed: allowed['modify any user standard text'], editOwnAllowed: allowed['modify own user standard text']});
    });
  }

  /**
   * Fetch standard texts.
   */
  fetchStandardTexts = () => {
    getStandardTexts(this.props.user.id, this.props.token, this.props.history, (response) => {
      if (response.status !== 200) {
        this.props.dispatch(addMessage('Fejl under hentning af standardtekst. Prøv venligst igen senere.', 'danger'));
        return;
      }

      response.json().then((data) => {
        var items = {};
        data.items.forEach((item) => {
          items[item.id] = item;
        });
        this.setState({standardTexts: items});
      });
    });
  }

  /**
   * Handle clicking the add standard text button.
   */
  handleAddStandardText = () => {
    var standardTextsC = this.state.standardTexts;
    var newId = 'new-' + Date.now();
    standardTextsC[newId] = {
      name: '',
      message: '',
      id: newId,
      user_id: this.props.user.id,
      new: true,
    };

    this.setState({standardTexts: standardTextsC});
  }

  /**
   * Delete standard text.
   */
  handleDeleteStandardText = (standardTextId) => {
    if (window.confirm('Er du sikker på at du vil slette standardtekst?')) {
      this.setState({doneWorking: false});

      deleteStandardText(this.props.user.id, standardTextId, this.props.token, this.props.history, (response) => {
        if (response.status !== 200) {
          this.props.dispatch(addMessage('Fejl under sletning af standardtekst. Prøv venligst igen senere.', 'danger'));
        }
        this.setState({doneWorking: true});
        this.fetchStandardTexts();
      });
    }
  }

  /** @inheritdoc */
  componentDidMount = () => {
    this.fetchStandardTexts();
    this.fetchEditAllowedPermission();
  }

  /** @inheritdoc */
  render() {
    return (
      <div className="tab-pane fade show active" id="standardtexts" role="tabpanel" aria-labelledby="standardtexts">
        <div className="widget">
          <WaitForState keys={['doneWorking']} state={this.state} />
          <h3 className="section-heading">Standardtekst</h3>
          <WaitForState state={this.state} keys={['standardTexts']}>
            {this.state.standardTexts && Object.keys(this.state.standardTexts).map((standardTextId) => {
              var standardText = this.state.standardTexts[standardTextId];
              return (
              <div className="form-group standard-text" key={standardText.id}>
                <input type="text" className="form-control" placeholder="Navn" onChange={(e) => {this.handleStandardTextUpdate(standardText.id, 'name', e)}} value={standardText.name} disabled={this.state.disabled ? 'disabled' : ''} />
                <textarea className="form-control" rows={3} value={standardText.message} onChange={(e) => {this.handleStandardTextUpdate(standardText.id, 'message', e)}} disabled={standardText.user_id === this.props.user.id && this.state.editOwnAllowed ? (this.state.disabled ? 'disabled' : '') : this.state.editAnyAllowed ? (this.state.disabled ? 'disabled' : '') : 'disabled'} />
                { !standardText.new && <button type="button" className="close remove-button" aria-label="Delete" onClick={(e) => {this.handleDeleteStandardText(standardText.id, e)}}>
                  <span aria-hidden="true">&times;</span>
                </button>}
              </div>
            )})}
          </WaitForState>
          <button className="btn btn-primary" onClick={this.handleAddStandardText}>Tilføj standardtekst</button>
        </div>
      </div>
    );
  }
}

export default withRouter(withUser(connect()(StandardTexts)));



// WEBPACK FOOTER //
// ./src/components/StandardTexts/index.js